// Contexto transitório em memória entre a consulta Fique em Dia e o simulador.
// Jamais transportar CPF/CNPJ, nome do cliente ou matrícula.
export type EtapaParcelamentoCampanha = 2 | 4

export type ParcelamentoCampanha = {
  origem: 'fique-em-dia'
  etapa: EtapaParcelamentoCampanha
  valorFinal: number
  maxParcelas: number
}

export const ENTRADA_PADRAO_FIQUE_EM_DIA = 0.10
export const PARCELA_MINIMA_FIQUE_EM_DIA = 50

export function prepararParcelamentoCampanha(
  etapa: EtapaParcelamentoCampanha,
  valorFinal: number,
  maxParcelas: number,
): ParcelamentoCampanha | null {
  if ((etapa !== 2 && etapa !== 4) ||
    !Number.isFinite(valorFinal) || valorFinal <= 0 ||
    !Number.isSafeInteger(Math.round(valorFinal * 100)) ||
    !Number.isInteger(maxParcelas) || maxParcelas <= 0 || maxParcelas > 120) {
    return null
  }
  return {
    origem: 'fique-em-dia',
    etapa,
    valorFinal: Math.round(valorFinal * 100) / 100,
    maxParcelas,
  }
}
